import Loading from '@/components/common/Loading'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import SchemaTags from "@/components/common/SchemaTags";
import React from 'react'


const Desktop = dynamic(() => import("@/components/outlet/DesktopWaterPark"), {
    loading: () => <Loading />
  })
  
  const Mobile = dynamic(() => import("@/components/outlet/MobileWaterPark"), {
    loading: () => <Loading />
  })
  
  
  const waterparkPosBillingSoftware = ({mobileView}) => {
      return(
          <>
          <Head>
                  <title> Water Park Billing Software | POS System for Water Parks</title>
                  <link rel="canonical" href="https://queuebuster.co/outlet/water-park-pos-billing-software" />
                  <link rel="alternate" href="https://queuebuster.co/outlet/water-park-pos-billing-software" hrefLang="en" />
                  <meta name="description" content="Streamline your water park operations with QueueBuster’s POS Billing Software. Easily manage inventory and billing of water park tickets, food, and accessories—all in one pos." />
                  <meta property="og:title" content="Make Every Splash Seamless with QueueBuster’s Water Park POS" />
                  <meta property="og:description" content="Manage your water park like a pro! QueueBuster’s POS Billing Software simplifies billing, tracks inventory, and keeps your park running in perfect order." />
                  <meta property="og:image" content="" />
                  <meta property="og:url" content="https://queuebuster.co/outlet/water-park-pos-billing-software" />
              </Head>
         <SchemaTags page="water-park-pos-billing-software" />
            {mobileView ?  <Mobile/>: <Desktop/>}
          </>
      )
  }
  


export default waterparkPosBillingSoftware